// src/services/common-api-service.ts

import { ConfigService } from '@services/config-service';
import { getCookie, setCookie } from '../utils/cookie-utils';
import { EncrDecr } from './encr-decr-service';

export class CommonApiService {
  private apiUrl: string = ConfigService.authApiUrl;
  private cookieApiUrl: string = ConfigService.cookieApiUrl;
  private sid: any = '';
  private headerSession: any = {};

  private async request(method: string, url: string, body?: any, headers?: any, requireResponseHeaders: boolean = false) {
    this.sid = getCookie('sid') || '';
    this.headerSession = { 'X-Session-Id': this.sid || '', 'sessionSharingDomain': String(ConfigService.sessionSharingDomain || false) };

    const options: RequestInit = {
      method,
      headers: {
        ...headers
      }
    };
    if (body instanceof FormData) {
      options.body = body;
    } else if (body !== undefined) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    //checking for session sharing domain to add session id in header
    if (ConfigService.sessionSharingDomain) {
      options.headers = {
        ...options.headers,
        ...this.headerSession
      };
    }
    try {
      const response = await fetch(`${this.apiUrl}${url}`, options);
      const sessionId = response?.headers?.get('X-Session-Id');
      //checking for session id in response header to set cookie
      if (sessionId && ConfigService.sessionSharingDomain) {
        const isHttp = window.location.protocol === 'https:' ? true : false;
        setCookie('sid', sessionId, { secure: isHttp });
      }
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      if (requireResponseHeaders) {
        return response;
      }
      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error(`API request failed: ${error.message}`);
    }
  }

  public async get(url: string, headers?: any) {
    return this.request('GET', url, undefined, headers);
  }

  public async post(url: string, body: any, headers?: any, encryption: boolean = true) {
    if (encryption && ConfigService.encryption?.enabled) {
      body = {
        postData: await EncrDecr.set(JSON.stringify(body))
      };
      const response = await this.request('POST', url, body, headers);
      return await EncrDecr.get(response.data);
    }
    const response = await this.request('POST', url, { postData: body }, headers);
    return response.json();
  }

  public async put(url: string, body: any, headers?: any) {
    return this.request('PUT', url, body, headers);
  }

  public async delete(url: string, headers?: any) {
    return this.request('DELETE', url, undefined, headers);
  }

  public async setCookie(url: string, body: any, headers?: any) {
    const options: RequestInit = {
      method: 'POST',
      headers: {
        ...headers
      }
    };
    if (body instanceof FormData) {
      options.body = body;
    } else if (body !== undefined) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.cookieApiUrl}${url}`, options);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await response.json();
      return result;
    } catch (error) {
      throw new Error(`API request failed: ${error.message}`);
    }
  }
}
